import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Recupera os dados do localStorage (se existirem) ao inicializar o estado
  const [companies, setCompanies] = useState(() => {
    const storedCompanies = localStorage.getItem('companies');
    return storedCompanies ? JSON.parse(storedCompanies) : [];
  });  

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : {};
  }); 

  const [accessKey, setAccessKey] = useState(() => {
    return localStorage.getItem('accessKey') || '';
  });

  const [selectedCompany, setSelectedCompany] = useState(() => {
    return localStorage.getItem('selectedCompany') ? parseInt(localStorage.getItem('selectedCompany')) : 0;
  });

  const [licenca, setLicenca] = useState(() => {
    return localStorage.getItem('licenca') || false;
  });

  // Atualiza o estado e armazena os dados no localStorage ao fazer login
  const updateLoginData = (data, key, auser) => {
    setCompanies(data);
    setAccessKey(key); 
    setUser(auser);
    localStorage.setItem('companies', JSON.stringify(data));
    localStorage.setItem('accessKey', key);    
    localStorage.setItem('user', JSON.stringify(auser));    
  };

  // Atualiza o localStorage sempre que selectedCompany ou licenca forem alterados
  useEffect(() => {
    localStorage.setItem('selectedCompany', selectedCompany);
  }, [selectedCompany]);

  useEffect(() => {
    localStorage.setItem('licenca', licenca);
  }, [licenca]);

  return (
    <AppContext.Provider
      value={{    
        user,    
        companies,
        accessKey,
        selectedCompany,
        licenca,
        setSelectedCompany,
        setLicenca,        
        updateLoginData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
